import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Rola',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa roli',
      type: 'string',
      fieldRequired: true
    },
    parentId: {
      type: 'number',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
